import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationTR from './locales/tr.json';

// Türkçe (ziyaretçilerin çoğu + yedek dil) ana pakette gelir: ilk çizim için
// ikinci bir indirme beklenmez. İngilizce (~255 KB) sadece gerektiğinde iner.
const loaders = {
  tr: () => Promise.resolve({ default: translationTR }),
  en: () => import('./locales/en.json'),
};

const lazyBackend = {
  type: 'backend',
  init() {},
  read(lng, ns, callback) {
    const load = loaders[lng];
    if (!load) return callback(null, {});
    load()
      .then(mod => callback(null, mod.default || mod))
      .catch(err => callback(err, false));
  },
};

const path = typeof window !== 'undefined' ? window.location.pathname : '/';
const initialLng = path === '/en' || path.startsWith('/en/') ? 'en' : 'tr';

// TAMAMEN TEMİZ BAŞLAT - HIÇBIR ŞEY KAYDETME
export const i18nReady = i18n
  .use(lazyBackend)
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: 'tr',
    debug: false,
    supportedLngs: ['tr', 'en'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
